import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_2 = { class: "row align-middle" };
const _hoisted_3 = { class: "col-sm-5 text-right pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$appHost.pageMeta.title,
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", {
                onSubmit: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.OnSubmit && _ctx.OnSubmit(...args)))
            }, [
                _createVNode(_component_g_text_field, {
                    "data-object": _ctx.$data,
                    "data-member": "codeConfirmed",
                    "data-mode": "model",
                    label: _ctx.$t('account.ActivationCodeWithNotes'),
                    mode: "text",
                    "show-clear-button": false,
                    onEnterKey: _ctx.execute
                }, null, 8, ["data-object", "label", "onEnterKey"]),
                (_ctx.hasError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-sm-7 my-auto text-left align-middle pr-0 small" }, null, -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_g_button, {
                            text: _ctx.$t('account.Activation.Confirm'),
                            disabled: _ctx.disableLogin,
                            "is-loading": _ctx.isLoading,
                            type: "submit"
                        }, null, 8, ["text", "disabled", "is-loading"])
                    ])
                ])
            ], 32)
        ]),
        _: 1
    }, 8, ["title"]));
}
